<template>
  <div>
    <AlertCard :isResponseError="isResponseError"></AlertCard>
    <b-row>
      <b-col cols="12"
             md="4">
        <UploadFileCard @send-request="getIdentifyResult"
                        @change-form-model-id="(event) => $store.commit('FORM_MODELID', event)"
                        @change-form-image="(event) => $store.commit('FORM_IMAGE', event)"
                        class="mb-3"
                        :form="$store.getters.form"
                        :model="modelOptions"
                        :isLoad="isLoad" />
      </b-col>
      <b-col cols="12"
             md="8">
        <ComprehensiveResultsCard :level="$store.getters.levelComprehensive"
                                  :isLoad="isLoad"
                                  class="mb-3" />
        <ResultCard v-bind="$store.getters.effectiveRecognitionResults"
                    :isLoad="isLoad"
                    :proportionOfScar="$store.getters.proportionOfScar" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
// component
import ComprehensiveResultsCard from '@/components/ComprehensiveResultsCard'
import ResultCard from '@/components/ResultCard'
import UploadFileCard from '@/components/UploadFileCard'
import AlertCard from '@/components/AlertCard'

// plugin
import { reverseErrorMessageToChinese } from '../utils/errorText'

export default {
  name: 'Home',
  components: {
    ComprehensiveResultsCard,
    ResultCard,
    UploadFileCard,
    AlertCard
  },
  filters: {},
  mixins: {},
  props: {},
  data: function () {
    return {
      standard: [], // 標準: 桶柑分級標準
      isLoad: false,
      isResponseError: {
        state: false,
        message: ''
      }
    }
  },
  computed: {
    // 模型選項： 模型整理成選項資料
    modelOptions () {
      return this.$store.getters.model.map((item) => ({
        text: item.name,
        value: item.id
      }))
    }
  },
  watch: {},
  async created () {
    try {
      this.standard = []
      await this.$store.dispatch('getModel')
    } catch (error) {
      console.error(error)
    }
  },
  methods: {
    async getIdentifyResult () {
      try {
        this.resetResponse()
        this.isLoad = true

        await this.$store.dispatch('getIdentification')
      } catch (error) {
        console.error(error)

        // 一旦錯誤，重置辨識請求結果為空
        this.$store.dispatch('resetIdentification')

        // 錯誤訊息
        this.isResponseError = {
          state: true,
          // 將錯誤代碼轉換為中文，目前是照後端給出的錯誤給予錯誤訊息，正在考慮用戶需要看到的轉換中...也不是都看得懂
          message: reverseErrorMessageToChinese(
            error.response.data.error.message
          )
        }
      } finally {
        this.isLoad = false
      }
    },
    resetResponse () {
      this.isResponseError = {
        state: false,
        message: ''
      }
    }
  }
}
</script>
